const CustomStylesheet = () => {
  return (
    <head>
      <link rel="stylesheet" href="/css/custom.css" />
    </head>
  );
};

export default CustomStylesheet;
